const question = {
    '0-1': { resolvedProfile: 'P' },
    '1-3': { values: ['P'] },
    '3-5': { values: ['P', 'E'], rejectedProfiles: ['D'] },
    '5+': { values: ['P', 'E', 'D'] },
    '8+': { values: ['E', 'D'] },
};

export default question;
